import React from 'react';
import Icon from '../../../Icon';

export enum PlaceChatMenuOption {
  SHARE = 'Share This Place',
  GUIDELINES = 'Community Guidelines',
  PLACE_PAGE = 'Place Page',
}

export const OPTIONS = [
  {
    option: PlaceChatMenuOption.GUIDELINES,
    renderIcon: (props: any) => <Icon iconName={'fi-rr-pennant'} {...props} />,
    color: 'red',
    text: PlaceChatMenuOption.GUIDELINES,
  },
  {
    option: PlaceChatMenuOption.PLACE_PAGE,
    renderIcon: (props: any) => <Icon iconName={'fi-sr-guitar'} {...props} />,
    color: '#5976bc',
    text: PlaceChatMenuOption.PLACE_PAGE,
  },
  {
    option: PlaceChatMenuOption.SHARE,
    renderIcon: (props: any) => <Icon iconName={'fi-rr-share'} {...props} />,
    color: 'lighterBlue',
    text: PlaceChatMenuOption.SHARE,
  },
];
